import HttpError from './HttpError';

export default class TooManyRequestsError extends HttpError {}
